var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "T1Iwf5.tif_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5,283.6c1.1-5.5,2.3-11,3.4-16.5c3.3-17.5,6.4-35,9.8-52.4c0.5-2.5,2.3-5,4.1-6.8 c52.6-52.8,105.3-105.4,158-158.1c9.9-9.9,20-19.7,29.8-29.9c6.7-6.9,13.7-13.2,23.6-14.8c2.6,0,5.3,0,7.9,0 c1.8,0.5,3.6,0.8,5.4,1.4c5.2,1.6,9.5,4.5,13.3,8.3c8.3,8.3,16.6,16.5,24.8,24.8c13.1,13.3,13.2,31.9,0,45.1 c-64.5,64.5-129,129-193.5,193.4c-1.8,1.8-4.5,3.2-7,3.7c-22.9,4.5-45.8,8.7-68.7,12.9C11,295.6,8.1,294,5,288.7 C5,287,5,285.3,5,283.6z M250.8,94.3c-15.1-15.1-30.2-30.2-45.1-45.1C150.3,104.5,94.8,160.1,39.4,215.5 c15,15,30.1,30.1,45.1,45.1C139.9,205.2,195.4,149.6,250.8,94.3z M263.7,82c3.2-3.2,6.2-6.3,9.2-9.4c6.5-6.6,6.6-14.4,0.1-21 c-5.4-5.5-10.9-11-16.4-16.4c-3.4-3.4-6.7-6.9-10.4-10c-4.6-3.9-11.3-4.4-16-0.7c-4.5,3.5-8.3,7.8-12.4,11.7 C233.3,51.5,248.4,66.6,263.7,82z M65.9,268c-11.4-11.4-22.7-22.7-34-34c-2.5,13.6-5.1,27.5-7.7,41.7 C38.4,273.1,52.3,270.5,65.9,268z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditar);
export default __webpack_public_path__ + "static/media/editar.a4eba5bbbf954f05ea37ecd82f97d8b3.svg";
export { ForwardRef as ReactComponent };